import React from 'react';
import {MenuItem} from 'react-pro-sidebar';
import {Link} from 'react-router-dom';
import {AdminWebRoute} from '../../../../../routes/AdminWebRoute';
import {TextHeading5} from '../../../../text/TextHeading5';
import {AssetIconChevron} from '../../../../../assets';
import {TextHeading6} from '../../../../text/TextHeading6';
import {TextHeading7} from '../../../../text/TextHeading7';

interface SidebarItemProps {
  title: string;
  to: AdminWebRoute;
  icon: React.ReactNode;
  currentRoute: string;
  onClick?: () => void;
}

export const SidebarItem = ({
  icon,
  currentRoute,
  title,
  to,
  onClick,
}: SidebarItemProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Link style={{textDecoration: 'none'}} to={to} onClick={handleClick}>
      <MenuItem
        suffix={
          <div style={{height: 20}}>
            <AssetIconChevron />
          </div>
        }
        style={{
          height: 50,
          transition: 'ease background-color 250ms',
        }}
        active={currentRoute.includes(to)} // Use startsWith for section-based highlighting
        icon={icon}>
        <div style={{width: 140, wordWrap: 'break-word', whiteSpace: 'normal'}}>
          <TextHeading7 text={title} />
        </div>
      </MenuItem>
    </Link>
  );
};
